import { render, staticRenderFns } from "./TextareaWithCounter.vue?vue&type=template&id=7371228c&scoped=true&"
import script from "./TextareaWithCounter.vue?vue&type=script&lang=js&"
export * from "./TextareaWithCounter.vue?vue&type=script&lang=js&"
import style0 from "./TextareaWithCounter.vue?vue&type=style&index=0&id=7371228c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7371228c",
  null
  
)

export default component.exports